export const COUNTY_EQUIVALENT_PLACE_TYPES = new Set(['district', 'place', 'locality', 'postcode']);

/** Mapbox types stored as `placeType: place` (finer than state/county). */
export const PLACE_BUCKET_EQUIVALENT_TYPES = new Set([
	'place',
	'locality',
	'neighborhood',
	'address',
	'poi',
]);

/** Includes `postcode` so ZIP / PIN / postal code queries return Mapbox suggestions (with country, region, etc.). */
export const SEARCH_GEOCODE_TYPES = 'country,region,district,place,locality,postcode';

/** Search suggestions when adding city / neighborhood / address-level areas. */
export const PLACE_SEARCH_GEOCODE_TYPES =
	'place,locality,neighborhood,address,poi,postcode,district';

/** Reverse-geocode types for map clicks in Locality mode (includes district when finer types missing). */
export const PLACE_REVERSE_GEOCODE_TYPES =
	'place,locality,neighborhood,address,poi,postcode,district';

export const FIT_CHIP_CLASS = 'inline-block max-w-full box-border truncate align-top !mb-2';
